import ODAS from '@/utils/api/odas';

let bootstrapPromise = null;
let bootstrapData = null;

const AgencyReferralNetwork = {
  bootstrap: () => {
    // return cached data immediately if already loaded
    if (bootstrapData) return Promise.resolve(bootstrapData);
    // deduplicate in-flight requests — all callers share the same promise
    if (bootstrapPromise) return bootstrapPromise;

    bootstrapPromise = ODAS.get('/api/organizations/agency_referral_networks/bootstrap').then((response) => {
      bootstrapData = response;
      bootstrapPromise = null;
      return response;
    });
    return bootstrapPromise;
  },

  hasActionableReferrals: () => {
    return ODAS.get('/api/organizations/agency_referral_networks/referrals');
  }
};

export default AgencyReferralNetwork;
